webpackJsonp([12010901253089898000],{

/***/ "./src/components/ProgressBar.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__("./src/components/ProgressBar.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EXPERIENCE_LIMIT = 5;
	
	var ProgressBar = function (_React$PureComponent) {
	  _inherits(ProgressBar, _React$PureComponent);
	
	  function ProgressBar(props) {
	    _classCallCheck(this, ProgressBar);
	
	    var _this = _possibleConstructorReturn(this, (ProgressBar.__proto__ || Object.getPrototypeOf(ProgressBar)).call(this, props));
	
	    _this.state = {
	      progress: 0
	    };
	    return _this;
	  }
	
	  _createClass(ProgressBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        _this2.setState({
	          progress: _this2.props.experience / EXPERIENCE_LIMIT * 100
	        });
	      }, 1);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          description = _props.description,
	          name = _props.name;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'progress-bar' },
	        _react2.default.createElement(
	          'div',
	          { className: 'progress-bar__name' },
	          name,
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'progress-bar__description' },
	            description
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'progress-bar__content' },
	          _react2.default.createElement('div', { className: 'progress-bar__progress', style: { width: this.state.progress + '%' } })
	        )
	      );
	    }
	  }]);
	
	  return ProgressBar;
	}(_react2.default.PureComponent);
	
	ProgressBar.defaultProps = {
	  name: 'Name',
	  experience: 2.5
	};
	
	exports.default = ProgressBar;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/ProgressBar.scss":
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/mark/Sites/Personal/markgaucher/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/mark/Sites/Personal/markgaucher/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/mark/Sites/Personal/markgaucher/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/mark/Sites/Personal/markgaucher/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/Users/mark/Sites/Personal/markgaucher/node_modules/babel-preset-env/lib/index.js\",\"/Users/mark/Sites/Personal/markgaucher/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/mark/Sites/Personal/markgaucher/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/skills.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ProgressBar = __webpack_require__("./src/components/ProgressBar.jsx");
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Skills = function Skills(_ref) {
	  var items = _ref.items;
	  return _react2.default.createElement(
	    'div',
	    { className: 'page' },
	    _react2.default.createElement(
	      'p',
	      null,
	      'Trying to create an exhaustive list of the languages and frameworks that I have used throughout the course of my career is challenging. Below is an overview of the tools I have engaged with on a consistent basis.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'I have always been eager to further develop and add to my developer toolbox. I have actively sought out opportunities to learn and apply new languages. My ability to pick up skills quickly has allowed me to contribute to quickly evolving projects in a meaningful way.'
	    ),
	    _react2.default.createElement('br', null),
	    items.map(function (item) {
	      return _react2.default.createElement(_ProgressBar2.default, _extends({ key: item.name }, item));
	    })
	  );
	};
	
	Skills.defaultProps = {
	  items: [{
	    name: 'HTML',
	    description: 'Senior',
	    experience: 5
	  }, {
	    name: 'CSS (Sass)',
	    description: 'Senior',
	    experience: 5
	  }, {
	    name: 'React.js',
	    description: 'Senior',
	    experience: 4
	  }, {
	    name: 'React Native',
	    description: 'Intermediate',
	    experience: 3.5
	  }, {
	    name: 'Node.js',
	    description: 'Intermediate',
	    experience: 2.5
	  }, {
	    name: 'PostgreSQL',
	    description: 'Junior',
	    experience: 2
	  }, {
	    name: 'MongoDB',
	    description: 'Intermediate',
	    experience: 2.5
	  }, {
	    name: 'GraphQL',
	    description: 'Intermediate',
	    experience: 3
	  }]
	};
	
	exports.default = Skills;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-pages-skills-js-e129097ff7d68600497a.js